import { createAction, props } from '@ngrx/store';
import { QuestionnaireDetail } from '../../models/questionnaire-detail';
import { QuestionnaireHistoryEntry } from '../../models/questionnaire-history-entry';
import { ScreeningDetail } from '../../models/screening-detail';
import { ScreeningHistoryEntry } from '../../models/screening-history-entry';
import { ScreeningsSummary } from '../../models/screenings-summary';
import { StudyReminderDetail } from '../../models/study-reminder-detail';

// Summary (list view) --------------------------------------------------------
export const getScreeningsSummary = createAction('[Screenings] Get Screenings Summary');

export const getScreeningsSummarySuccess = createAction(
  '[Screenings] Get Screenings Summary Success',
  props<{ summary: ScreeningsSummary }>()
);

export const getScreeningsSummaryFailure = createAction(
  '[Screenings] Get Screenings Summary Failure',
  props<{ error: unknown }>()
);

// Questionnaire history ------------------------------------------------------
export const getQuestionnaireHistory = createAction(
  '[Screenings] Get Questionnaire History',
  props<{ templateKey: string }>()
);

export const getQuestionnaireHistorySuccess = createAction(
  '[Screenings] Get Questionnaire History Success',
  props<{ entries: QuestionnaireHistoryEntry[] }>()
);

export const getQuestionnaireHistoryFailure = createAction(
  '[Screenings] Get Questionnaire History Failure',
  props<{ error: unknown }>()
);

// Questionnaire detail -------------------------------------------------------
export const getQuestionnaireDetail = createAction(
  '[Screenings] Get Questionnaire Detail',
  props<{ patientQuestionnaireId: number }>()
);

export const getQuestionnaireDetailSuccess = createAction(
  '[Screenings] Get Questionnaire Detail Success',
  props<{ detail: QuestionnaireDetail }>()
);

export const getQuestionnaireDetailFailure = createAction(
  '[Screenings] Get Questionnaire Detail Failure',
  props<{ error: unknown }>()
);

// Screening (procedure) history ----------------------------------------------
export const getScreeningHistory = createAction('[Screenings] Get Screening History', props<{ conceptKey: string }>());

export const getScreeningHistorySuccess = createAction(
  '[Screenings] Get Screening History Success',
  props<{ entries: ScreeningHistoryEntry[] }>()
);

export const getScreeningHistoryFailure = createAction(
  '[Screenings] Get Screening History Failure',
  props<{ error: unknown }>()
);

// Screening (procedure) detail -----------------------------------------------
export const getScreeningDetail = createAction(
  '[Screenings] Get Screening Detail',
  props<{ patientScreeningId: number }>()
);

export const getScreeningDetailSuccess = createAction(
  '[Screenings] Get Screening Detail Success',
  props<{ detail: ScreeningDetail }>()
);

export const getScreeningDetailFailure = createAction(
  '[Screenings] Get Screening Detail Failure',
  props<{ error: unknown }>()
);

// Study-reminder detail ------------------------------------------------------
export const getReminderDetail = createAction(
  '[Screenings] Get Reminder Detail',
  props<{ patientStudyReminderId: number }>()
);

export const getReminderDetailSuccess = createAction(
  '[Screenings] Get Reminder Detail Success',
  props<{ detail: StudyReminderDetail }>()
);

export const getReminderDetailFailure = createAction(
  '[Screenings] Get Reminder Detail Failure',
  props<{ error: unknown }>()
);
